export const truncateText = (text: string, length: number, clamp?: any) => {
	clamp = clamp || '...'
	const node = document.createElement('div')
	node.innerHTML = text
	const content = node.textContent
	return content.length > length ? content.slice(0, length) + clamp : content
}
